/* Franja de anuncios Vanessa v2 */
(function(){
  var re = /\/cart\/(add|change|update|clear)/;
  function ping(){ document.dispatchEvent(new CustomEvent('vn:cart-changed')); }
  if (!window.__vnCartHook) {
    window.__vnCartHook = true;
    if (window.fetch) {
      var of = window.fetch;
      window.fetch = function(input){
        var u = (input && input.url) || String(input || '');
        var p = of.apply(this, arguments);
        if (re.test(u)) p.then(ping, function(){});
        return p;
      };
    }
    var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function(m, u){ this.__vnu = u; return xo.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function(){ if (re.test(String(this.__vnu || ''))) this.addEventListener('load', ping); return xs.apply(this, arguments); };
  }

  function fmt(cents){ return '$' + Math.ceil(Math.max(cents, 0) / 100).toLocaleString('es-CO'); }

  function init(root){
    if (!root || root.__vnInit) return;
    root.__vnInit = true;
    var track = root.querySelector('.vn-ab__track');
    var items = [].slice.call(root.querySelectorAll('[data-vn-item]'));
    var free = root.querySelector('[data-vn-free]');
    var speed = (parseInt(root.getAttribute('data-speed'), 10) || 5) * 1000;
    var mq = window.matchMedia('(max-width:1024px)');
    var idx = 0, timer = null, paused = false, rotating = false, lastSt = null;

    function setHeight(){ try { document.documentElement.style.setProperty('--announcement-height2', root.offsetHeight + 'px'); } catch(e){} }
    function activate(i){
      idx = i;
      items.forEach(function(el, n){
        var on = n === i, a = el.querySelector('a');
        el.classList.toggle('is-active', on);
        if (rotating) {
          el.setAttribute('aria-hidden', on ? 'false' : 'true');
          if (a) a.tabIndex = on ? 0 : -1;
        } else {
          el.removeAttribute('aria-hidden');
          if (a) a.removeAttribute('tabindex');
        }
      });
    }
    function next(){ if (!paused && !document.hidden && items.length > 1) activate((idx + 1) % items.length); }
    function stop(){ if (timer) { clearInterval(timer); timer = null; } }
    function start(){ stop(); if (rotating && items.length > 1) timer = setInterval(next, speed); }
    function layout(){
      if (!track) return;
      root.classList.remove('is-rotating');
      rotating = mq.matches || root.getAttribute('data-desktop') === 'rotate' || track.scrollWidth > track.clientWidth + 2;
      root.classList.toggle('is-rotating', rotating);
      activate(idx); start(); setHeight();
    }
    function render(cart){
      if (!free || !cart) return;
      var th = parseInt(free.getAttribute('data-threshold'), 10) || 0;
      var total = parseInt(cart.total_price, 10) || 0;
      var count = parseInt(cart.item_count, 10) || 0;
      var st = !count ? 'empty' : (total >= th ? 'done' : 'progress');
      free.querySelectorAll('[data-vn-state]').forEach(function(s){ s.hidden = s.getAttribute('data-vn-state') !== st; });
      free.querySelectorAll('[data-vn-th]').forEach(function(s){ s.textContent = fmt(th); });
      free.querySelectorAll('[data-vn-left]').forEach(function(s){ s.textContent = fmt(th - total); });
      if (lastSt !== null && st !== lastSt && rotating) { activate(items.indexOf(free)); start(); }
      lastSt = st;
    }
    render({ total_price: root.getAttribute('data-vn-total'), item_count: root.getAttribute('data-vn-count') });

    var rt = null;
    function refresh(){
      clearTimeout(rt);
      rt = setTimeout(function(){
        var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(base + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
          .then(function(r){ return r.json(); }).then(render).catch(function(){});
      }, 250);
    }
    document.addEventListener('vn:cart-changed', refresh);
    window.addEventListener('pageshow', function(e){ if (e.persisted) refresh(); });

    root.addEventListener('mouseenter', function(){ paused = true; });
    root.addEventListener('mouseleave', function(){ paused = false; });
    root.addEventListener('focusin', function(){ paused = true; });
    root.addEventListener('focusout', function(){ paused = false; });
    root.addEventListener('click', function(e){
      var a = e.target.closest('[data-vn-track]');
      if (!a) return;
      var lbl = a.getAttribute('data-vn-label') || '';
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'announcement_click', announcement: lbl });
        if (typeof window.gtag === 'function') window.gtag('event', 'announcement_click', { announcement: lbl });
      } catch(err){}
    });
    document.addEventListener('shopify:block:select', function(e){
      var i = items.findIndex(function(el){ return el.getAttribute('data-block-id') === (e.detail && e.detail.blockId); });
      if (i > -1) { paused = true; activate(i); }
    });
    document.addEventListener('shopify:block:deselect', function(){ paused = false; });

    var rz = null;
    window.addEventListener('resize', function(){ clearTimeout(rz); rz = setTimeout(layout, 150); });
    layout();
  }

  function initAll(){ document.querySelectorAll('.vn-ab').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();